var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.502,
    height: 22,
    viewBox: "0 0 27.502 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#180058;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.238,19.687l-2.364-1.826a1.354,1.354,0,0,0,1.255-1.336V5.48a1.377,1.377,0,0,0-2.166-1.109L19.253,7.62v5.9l-1.375-1.061V4.805a2.054,2.054,0,0,0-2.054-2.054H5.325L1.956.147a.69.69,0,0,0-.967.12L.147,1.35a.685.685,0,0,0,.12.963L1.836,3.525l16.042,12.4,7.671,5.93a.69.69,0,0,0,.967-.12l.842-1.087a.681.681,0,0,0-.12-.963ZM1.376,17.2A2.054,2.054,0,0,0,3.43,19.253H15.824A2.039,2.039,0,0,0,17.1,18.8L1.376,6.649Z",
    transform: "translate(-0.002 -0.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSlash);
export default __webpack_public_path__ + "static/media/video-slash.64f63786545e4531a24e5a2d9cf42dd9.svg";
export { ForwardRef as ReactComponent };